import { useRef, useEffect, useState } from 'react';
import { useMediaQuery } from '@material-ui/core';
import ReactEcharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';
import moment from 'moment'

const ExpenseSpeedometer = ({ data, t }) => {
  function getRemainDays() {
    const today = moment()
    const lastDayOfTheMonth = moment().endOf('month')

    return lastDayOfTheMonth.diff(today, 'days')
  }
  
  const limit = data.totalConversations || 0
  const consumed = data.usageTokensByMonth || 0;
  const isMobile = useMediaQuery('(max-width: 600px)');
  const { t: trans} = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' });
  const days = getRemainDays()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function handlerResizeSpeedometerLabel(type) {
    if (windowWidth > 1200) {
      return type === 1 ? parseInt(windowWidth * 0.009) : parseInt(windowWidth * 0.008);
    } else {
      return type === 1 ? 16 : 10;
    }
  };
  
  if (limit <= 0) return null

  const getChartOption = () => {
    const numConsumed = parseFloat((consumed).replace(/,/g, ''))
    const numLimit = parseFloat((limit).replace(/,/g, ''))
    const percentage = Math.min((numConsumed / numLimit) * 100, 100).toFixed(0)
    const labelColor = numConsumed >= numLimit ? '#FF0000' : '#00a4e0'

    return {
      series: [{
        height: '10px',
        type: 'gauge',
        center: ['50%', '80%'],
        radius: isMobile ? '100%' : '80%',
        startAngle: 180,
        endAngle: 0,
        min: 0,
        max: numLimit,
        itemStyle: { color: labelColor },
        progress: { show: true, width: 16 },
        pointer: { show: false },
        axisTick: {
          show: false, // Oculta las marcas pequeñas del eje
        },
        splitLine: {
          show: false, // Oculta las líneas divisorias
        },
        axisLabel: {
          show: false, // Oculta los números (0, 25, 50...)
        },
        detail: {
          offsetCenter: [0, windowWidth > 1600 ? '-30%' : windowWidth > 1250 ? '20%' : '60%'],
          formatter: `{value|${percentage}%}\n{text|${t('consumed')}}`,
          rich: {
            value: { fontSize: handlerResizeSpeedometerLabel(1), color: '#000', lineHeight: 32, fontWeight: 'bold' },
            text: { fontSize: handlerResizeSpeedometerLabel(2), color: '#000', lineHeight: 15, fontWeight: 'bold' }
          }
        },
        data: [{ value: numConsumed }]
      }]
    }
  }

  return (
    <div onClick={() => null} className="expense-speedometer">
      <p class='dashboardView-card-title'>{t('expenseSpeedometerTitle')}</p>
      <div className="expense-speedometer-container">
        <div className="expense-speedometer-content">
          <div className="expense-speedometer-values">
            <span>
              <label>{trans('usedConversations')}</label>
              <label>{consumed?.toLocaleString('en-US') || '0.00'}</label>
            </span>
            <span>
              <label>{trans('includedConversations')}</label>
              <label>{limit?.toLocaleString('en-US') || '0.00'}</label>
            </span>
          </div>
          <div className="speedometer">
            <div className="echart-container">
              <ReactEcharts
                option={getChartOption()}
                style={{
                  width: isMobile ? '100%' : '50%',
                  height: isMobile ? '150px' : '200px'
                }}
              />
            </div>
          </div>
          <label className={`speedometer-left-days ${(windowWidth <= 1600 && windowWidth > 1250) ? 'mt-10' : windowWidth < 1250 && 'mt-20'}`}>{t('infoLeftDays', {days})}</label>
        </div>
      </div>
    </div>
  )
}

export {ExpenseSpeedometer as default}